"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditLogTable = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const use_custom_compare_1 = require("use-custom-compare");
const antd_1 = require("antd");
const lodash_1 = __importDefault(require("lodash"));
const DateTimeUtils_1 = require("src/configeek_assets/src/system/mics/DateTimeUtils");
const AuditLogTableDataProvider_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/audit/AuditLogTableDataProvider");
const AuditLogPageDataProvider_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/audit/model/AuditLogPageDataProvider");
const ProjectConfigStoreDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectConfigStoreDataProvider");
const CopyablePrincipalComponent_1 = require("src/configeek_assets/src/components/common/widget/CopyablePrincipalComponent");
const CopyableTextComponent_1 = require("src/configeek_assets/src/components/common/widget/CopyableTextComponent");
const ValueOrEmptyStringComponent_1 = require("src/configeek_assets/src/components/loggedIn/common/ValueOrEmptyStringComponent");
const i18_1 = require("src/configeek_assets/src/i18");
const DiffComponent_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/audit/DiffComponent");
const CodeBlock_1 = require("src/configeek_assets/src/components/common/widget/CodeBlock");
const ShowNewLinesSettingsComponent_1 = require("src/configeek_assets/src/components/common/widget/ShowNewLinesSettingsComponent");
const react_dom_1 = require("react-dom");
const AutoWrapContainer_1 = require("src/configeek_assets/src/components/loggedIn/common/AutoWrapContainer");
const AuditLogPageModelProvider_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/audit/model/AuditLogPageModelProvider");
const AuditLogTable = () => {
    const pageDataContext = (0, AuditLogPageDataProvider_1.useAuditLogPageDataContext)();
    const tableDataContext = (0, AuditLogTableDataProvider_1.useAuditLogTableDataContext)();
    const urlJSONModel = pageDataContext.stateFns.getURLJSONModel();
    const newLinesVisible = urlJSONModel.getView().getNewLinesVisible().getValue() || false;
    const feature = pageDataContext.state;
    const tableColumns = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        return [
            {
                title: "Update Id",
                render: (value, record) => record.record.updateId,
                width: 100,
            },
            {
                title: "Key",
                render: (value, record) => React.createElement(AutoWrapContainer_1.AutoWrapContainer, null, record.record.parameterName),
                width: 200,
            },
            {
                title: "Value",
                render: (value, record) => {
                    if (record.record.action === "remove") {
                        return null;
                    }
                    return React.createElement(AutoWrapContainer_1.AutoWrapContainer, null,
                        React.createElement(ValueOrEmptyStringComponent_1.ValueOrEmptyStringComponent, { value: record.record.parameterValueNew, showViewLines: newLinesVisible }));
                },
                width: 300,
            },
            {
                title: "Previous Value",
                render: (value, record) => {
                    if (record.record.action === "new") {
                        return null;
                    }
                    return React.createElement(AutoWrapContainer_1.AutoWrapContainer, null,
                        React.createElement(ValueOrEmptyStringComponent_1.ValueOrEmptyStringComponent, { value: record.record.parameterValueOld, showViewLines: newLinesVisible }));
                },
                width: 300,
            },
            {
                title: "Action",
                render: (value, record) => {
                    const color = record.record.action === "new" ? "green" :
                        record.record.action === "modify" ? "blue" : "red";
                    return React.createElement(antd_1.Tag, { color: color }, record.record.action);
                }
            },
            {
                title: "User",
                render: (value, record) => {
                    if (lodash_1.default.isEmpty(record.participantName)) {
                        return React.createElement(CopyablePrincipalComponent_1.CopyablePrincipalComponent, { principal: record.record.principal, truncateLength: 20 });
                    }
                    return React.createElement(antd_1.Space, { direction: "vertical", size: 0 },
                        React.createElement(AutoWrapContainer_1.AutoWrapContainer, null, record.participantName),
                        React.createElement("span", null,
                            "(",
                            React.createElement(CopyablePrincipalComponent_1.CopyablePrincipalComponent, { principal: record.record.principal, truncateLength: 10 }),
                            ")"));
                },
                width: 140,
            },
            {
                title: "Time, UTC",
                render: (value, record) => {
                    return DateTimeUtils_1.DateTimeUtils.formatDate(record.record.timeMillis, "dayTimeSeconds");
                },
                width: 120,
            },
            {
                title: "",
                render: (value, record) => {
                    const viewButton = React.createElement(ViewAuditLogRecordButton, { record: record.record });
                    switch (record.record.action) {
                        case "modify": {
                            return React.createElement(antd_1.Space, { direction: "vertical", size: 0 },
                                viewButton,
                                React.createElement(CompareAuditLogRecordButton, { record: record.record }));
                        }
                        case "new":
                        case "remove":
                            return viewButton;
                        default:
                            return null;
                    }
                },
                width: 123,
            }
        ];
    }, [newLinesVisible], lodash_1.default.isEqual);
    return React.createElement("div", { style: { marginTop: 16 } },
        React.createElement(AuditLogTableWrapper, { tableStatus: tableDataContext.tableStatus },
            React.createElement(antd_1.Table, { dataSource: tableDataContext.data, columns: tableColumns, loading: feature === null || feature === void 0 ? void 0 : feature.status.inProgress, rowKey: record => `${record.record.updateId}`, pagination: false, scroll: { x: 1300 }, showSorterTooltip: false }),
            React.createElement(LoadMoreButton, null)));
};
exports.AuditLogTable = AuditLogTable;
const AuditLogTableWrapper = (props) => {
    let overlay = null;
    switch (props.tableStatus) {
        case "parametersChanged": {
            overlay = React.createElement(antd_1.Alert, { type: "warning", message: i18_1.i18.project.audit.filterParametersChanged, showIcon: true });
            break;
        }
        case "notLoaded":
            break;
        case "loaded":
            break;
    }
    const hasOverlay = !lodash_1.default.isEmpty(overlay);
    if (hasOverlay) {
        const className = `auditLogTableWrapper${hasOverlay ? " auditLogTableWrapperMasked" : ""}`;
        return React.createElement("div", { className: className },
            React.createElement("div", { className: "auditLogTable" }, props.children),
            hasOverlay && React.createElement("div", { className: "auditLogTableOverlay" }, overlay));
    }
    return React.createElement(React.Fragment, null, props.children);
};
const LoadMoreButton = () => {
    var _a;
    const pageDataContext = (0, AuditLogPageDataProvider_1.useAuditLogPageDataContext)();
    const pageModelContext = (0, AuditLogPageModelProvider_1.useAuditLogPageModelContext)();
    const tableDataContext = (0, AuditLogTableDataProvider_1.useAuditLogTableDataContext)();
    const jsonModel = pageModelContext.pageModelStateFns.getFormJSONModel();
    const isDescending = jsonModel.getOrderValue() === "descending";
    const outerAuditRecord = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        var _a, _b;
        const mostOldestAuditRecord = isDescending ?
            (_a = lodash_1.default.minBy(tableDataContext.data, v => v.record.updateId)) === null || _a === void 0 ? void 0 : _a.record :
            (_b = lodash_1.default.maxBy(tableDataContext.data, v => v.record.updateId)) === null || _b === void 0 ? void 0 : _b.record;
        if (!!process.env.IS_TEST_SERVER) {
            console.log("got outerAuditRecord with isDescending", isDescending, mostOldestAuditRecord);
        }
        return mostOldestAuditRecord;
    }, [tableDataContext.data, isDescending], lodash_1.default.isEqual);
    const onClick = (0, use_custom_compare_1.useCustomCompareCallback)(() => {
        if (outerAuditRecord) {
            if (!!process.env.IS_TEST_SERVER) {
                console.log("onLoadMore onClick: isDescending outerAuditRecord", isDescending, outerAuditRecord);
            }
            pageDataContext.stateFns.onLoadMore(outerAuditRecord.updateId);
        }
    }, [outerAuditRecord, pageDataContext.stateFns.onLoadMore, isDescending], lodash_1.default.isEqual);
    const inProgress = pageDataContext.state.status.inProgress;
    return React.createElement("div", { style: { marginTop: 20 } },
        React.createElement(antd_1.Button, { onClick: onClick, disabled: inProgress || ((_a = pageDataContext.state.data) === null || _a === void 0 ? void 0 : _a.noMoreRecords), loading: inProgress }, "Load More"));
};
const ViewAuditLogRecordButton = (props) => {
    switch (props.record.action) {
        case "new":
            return React.createElement(ViewAuditLogNewRecordButton, { record: props.record });
        case "remove":
            return React.createElement(ViewAuditLogRemoveRecordButton, { record: props.record });
        case "modify":
            return React.createElement(ViewAuditLogModifyRecordButton, { record: props.record });
        default:
            return null;
    }
};
const ViewAuditLogNewRecordButton = (props) => {
    const { parameterName, parameterValueNew, timeMillis } = props.record;
    const time = DateTimeUtils_1.DateTimeUtils.formatDate(timeMillis, "dayTimeSeconds");
    const [newLinesVisible, setNewLinesVisible] = (0, react_1.useState)(false);
    const [visible, setVisible] = (0, react_1.useState)(false);
    const onClick = (0, react_1.useCallback)(() => {
        setVisible(true);
    }, []);
    const onCancel = (0, react_1.useCallback)(() => {
        (0, react_dom_1.unstable_batchedUpdates)(() => {
            setVisible(false);
            setNewLinesVisible(false);
        });
    }, []);
    const closeButton = React.createElement(antd_1.Button, { onClick: onCancel, key: "close" }, "Close");
    const newLinesVisibleSettings = React.createElement(ShowNewLinesSettingsComponent_1.ShowNewLinesSettingsComponent, { value: newLinesVisible, onChange: setNewLinesVisible });
    const value = (0, ProjectConfigStoreDataProvider_1.getConfigurationValueText)(parameterValueNew) || "";
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Modal, { width: 900, visible: visible, title: `Parameter "${parameterName}" was created on ${time}`, footer: [closeButton], onCancel: onCancel, className: "ug-modal", closable: false, destroyOnClose: true },
            newLinesVisibleSettings,
            React.createElement(antd_1.Form, { layout: "vertical" },
                React.createElement(antd_1.Form.Item, { label: React.createElement(CopyableTextComponent_1.CopyableTextComponent, { label: "Value", copyText: value, color: "lightgray" }) },
                    React.createElement(CodeBlock_1.CodeBlock, { value: newLinesVisible ? (0, ValueOrEmptyStringComponent_1.replaceNewLinesWithPilcrowSign)(value, true) : value })))),
        React.createElement(antd_1.Button, { type: "link", onClick: onClick }, "View"));
};
const ViewAuditLogRemoveRecordButton = (props) => {
    const { parameterName, parameterValueOld, timeMillis } = props.record;
    const time = DateTimeUtils_1.DateTimeUtils.formatDate(timeMillis, "dayTimeSeconds");
    const [newLinesVisible, setNewLinesVisible] = (0, react_1.useState)(false);
    const [visible, setVisible] = (0, react_1.useState)(false);
    const onClick = (0, react_1.useCallback)(() => {
        setVisible(true);
    }, []);
    const onCancel = (0, react_1.useCallback)(() => {
        (0, react_dom_1.unstable_batchedUpdates)(() => {
            setVisible(false);
            setNewLinesVisible(false);
        });
    }, []);
    const closeButton = React.createElement(antd_1.Button, { onClick: onCancel, key: "close" }, "Close");
    const newLinesVisibleSettings = React.createElement(ShowNewLinesSettingsComponent_1.ShowNewLinesSettingsComponent, { value: newLinesVisible, onChange: setNewLinesVisible });
    const value = (0, ProjectConfigStoreDataProvider_1.getConfigurationValueText)(parameterValueOld) || "";
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Modal, { width: 900, visible: visible, title: `Parameter "${parameterName}" was removed on ${time}`, footer: [closeButton], onCancel: onCancel, className: "ug-modal", closable: false, destroyOnClose: true },
            newLinesVisibleSettings,
            React.createElement(antd_1.Form, { layout: "vertical" },
                React.createElement(antd_1.Form.Item, { label: React.createElement(CopyableTextComponent_1.CopyableTextComponent, { label: "Removed Value", copyText: value, color: "lightgray" }) },
                    React.createElement(CodeBlock_1.CodeBlock, { value: newLinesVisible ? (0, ValueOrEmptyStringComponent_1.replaceNewLinesWithPilcrowSign)(value, true) : value })))),
        React.createElement(antd_1.Button, { type: "link", onClick: onClick }, "View"));
};
const ViewAuditLogModifyRecordButton = (props) => {
    const { parameterName, parameterValueOld, parameterValueNew, timeMillis } = props.record;
    const time = DateTimeUtils_1.DateTimeUtils.formatDate(timeMillis, "dayTimeSeconds");
    const [newLinesVisible, setNewLinesVisible] = (0, react_1.useState)(false);
    const [visible, setVisible] = (0, react_1.useState)(false);
    const onClick = (0, react_1.useCallback)(() => {
        setVisible(true);
    }, []);
    const onCancel = (0, react_1.useCallback)(() => {
        (0, react_dom_1.unstable_batchedUpdates)(() => {
            setVisible(false);
            setNewLinesVisible(false);
        });
    }, []);
    const closeButton = React.createElement(antd_1.Button, { onClick: onCancel, key: "close" }, "Close");
    const newLinesVisibleSettings = React.createElement(ShowNewLinesSettingsComponent_1.ShowNewLinesSettingsComponent, { value: newLinesVisible, onChange: setNewLinesVisible });
    const oldValue = (0, ProjectConfigStoreDataProvider_1.getConfigurationValueText)(parameterValueOld) || "";
    const newValue = (0, ProjectConfigStoreDataProvider_1.getConfigurationValueText)(parameterValueNew) || "";
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Modal, { width: "100%", visible: visible, title: `Parameter "${parameterName}" was modified on ${time}`, footer: [closeButton], onCancel: onCancel, className: "ug-modal", closable: false, destroyOnClose: true },
            newLinesVisibleSettings,
            React.createElement(antd_1.Form, { layout: "vertical" },
                React.createElement(antd_1.Row, { gutter: 16 },
                    React.createElement(antd_1.Col, { span: 12 },
                        React.createElement(antd_1.Form.Item, { label: React.createElement(CopyableTextComponent_1.CopyableTextComponent, { label: "Previous Value", copyText: oldValue, color: "lightgray" }) },
                            React.createElement(CodeBlock_1.CodeBlock, { value: newLinesVisible ? (0, ValueOrEmptyStringComponent_1.replaceNewLinesWithPilcrowSign)(oldValue, true) : oldValue }))),
                    React.createElement(antd_1.Col, { span: 12 },
                        React.createElement(antd_1.Form.Item, { label: React.createElement(CopyableTextComponent_1.CopyableTextComponent, { label: "New Value", copyText: newValue, color: "lightgray" }) },
                            React.createElement(CodeBlock_1.CodeBlock, { value: newLinesVisible ? (0, ValueOrEmptyStringComponent_1.replaceNewLinesWithPilcrowSign)(newValue, true) : newValue })))))),
        React.createElement(antd_1.Button, { type: "link", onClick: onClick }, "View"));
};
/*
https://codesandbox.io/s/bh1vz?file=/index.js
*/
const CompareAuditLogRecordButton = (props) => {
    const { parameterName, parameterValueOld, parameterValueNew, timeMillis } = props.record;
    const time = DateTimeUtils_1.DateTimeUtils.formatDate(timeMillis, "dayTimeSeconds");
    const [visible, setVisible] = (0, react_1.useState)(false);
    const onClick = (0, react_1.useCallback)(() => {
        setVisible(true);
    }, []);
    const onCancel = (0, react_1.useCallback)(() => {
        setVisible(false);
    }, []);
    const closeButton = React.createElement(antd_1.Button, { onClick: onCancel, key: "close" }, "Close");
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Modal, { width: 900, visible: visible, title: React.createElement(React.Fragment, null,
                "Parameter \"",
                parameterName,
                "\" was modified on ",
                time), footer: [closeButton], onCancel: onCancel, className: "ug-modal", closable: false, destroyOnClose: true },
            React.createElement(antd_1.Typography.Paragraph, { style: { marginTop: 20, fontFamily: "monospace" } },
                React.createElement("pre", null,
                    React.createElement(DiffComponent_1.DiffComponent, { oldValue: (0, ProjectConfigStoreDataProvider_1.getConfigurationValueText)(parameterValueOld) || "", newValue: (0, ProjectConfigStoreDataProvider_1.getConfigurationValueText)(parameterValueNew) || "", style: { fontSize: "0.9em" } })))),
        React.createElement(antd_1.Button, { type: "link", onClick: onClick }, "Compare"));
};
